import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import { PromoCountdown } from './PromoCountdown';
import { pricing, warrantyCopy } from '../data/promotion';
import { useActiveSale } from '../hooks/useActiveSale';
import { money } from './QuantityStepper';

/**
 * The first pricing information a visitor sees: savings, regular vs current
 * price, total separate value, the warranty and the weekly countdown.
 * The three prices ($166.60 value, $79.95 regular, $49.95 current) are kept
 * visually distinct so they are never confused with each other.
 */
export function LaunchOfferPanel() {
  const sale = useActiveSale();
  return <div className="mt-8 grid gap-px border border-white/12 bg-white/10 lg:grid-cols-[1.25fr_1fr]" data-id="element-303" data-mp="17dzjp9jlf3nb">
      <div className="bg-ink-950 p-5 sm:p-7" data-id="element-304" data-mp="1v3k31tjns2x4">
        <div className="flex flex-wrap items-center gap-3" data-id="element-305" data-mp="1v2s72hm5g36b">
          <span className="bg-grit-500 px-3 py-1.5 font-display text-2xl font-extrabold uppercase leading-none text-ink-950 sm:text-3xl" data-id="element-306" data-mp="1zu0hngz7tul2">
            Save {money(pricing.save).replace('.00', '')}
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-307" data-mp="289682z524to8">★ {sale.name}</span>
        </div>
        <p className="mt-3 max-w-xl text-[14px] font-medium text-steel-300" data-id="element-308" data-mp="2m0um57yv9s7u">{sale.tagline}</p>

        <p className="mt-5 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-309" data-mp="2h89r6348592q">
          <span className="pb-1 text-lg text-steel-400" data-id="element-310" data-mp="2vxpiplbkxijh">
            <span className="sr-only" data-id="element-311" data-mp="2vwe6cx42j2gr">Regular price </span>
            <span className="line-through" data-id="element-312" data-mp="2qzxi82wvco3o">{money(pricing.regular)}</span>
          </span>
          <span className="font-display text-6xl font-extrabold leading-none text-offwhite sm:text-7xl" data-id="element-313" data-mp="34z6voutox43y">
            {money(pricing.launch)}
          </span>
        </p>
        <p className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-grit-500" data-id="element-314" data-mp="1akw6gl96o7xn">
          You save {money(pricing.save)} from the regular price
        </p>

        <dl className="mt-5 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2" data-id="element-315" data-mp="16l3tlwcrbfmh">
          <div className="bg-ink-900 px-4 py-3" data-id="element-316" data-mp="35pvj872hmui7">
            <dt className="text-[10px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-317" data-mp="3amlxqpyn9i1i">Total separate value</dt>
            <dd className="mt-1 font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-318" data-mp="3flysrxzo5vf6">
              {money(pricing.separateValue)}
            </dd>
          </div>
          <Link to="/legal/guarantee" className="flex items-center gap-3 bg-ink-900 px-4 py-3 transition-colors duration-150 ease-grit hover:bg-ink-850 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-319" data-mp="3on6frjwqj9ty">
            <ShieldCheckIcon className="h-7 w-7 shrink-0 text-grit-500" aria-hidden="true" data-id="element-320" data-mp="283vj4vdwwpt" />
            <span data-id="element-321" data-mp="75vkpr4na4qb">
              <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-322" data-mp="78hxc56e7afe">
                {warrantyCopy.value}
              </span>
              <span className="mt-0.5 block font-display text-lg font-bold uppercase leading-tight text-offwhite" data-id="element-323" data-mp="g7wkauncp2v5">
                Lifetime warranty free on every multi-pack
              </span>
            </span>
          </Link>
        </dl>
      </div>

      <div className="flex flex-col justify-center bg-ink-950 p-5 sm:p-7" data-id="element-324" data-mp="1rofyxlq1ks4k">
        <PromoCountdown data-id="element-325" data-mp="1rqk03vwk3d15" />
        <p className="mt-4 text-[13px] leading-relaxed text-steel-400" data-id="element-326" data-mp="1mpcuo3hvypxn">
          Every system ships complete: glasses, 3 lenses, hard case, pouch, cloth, USB cable, anti-fog spray, guide
          and authenticity card.
        </p>
      </div>
    </div>;
}